import { useQuery } from '@tanstack/react-query';

import { getCondutor } from '@services/detran/condutor.service';

export function useCondutor(cpf: string) {
  return useQuery({
    queryKey: ['condutor', cpf],
    queryFn: () => getCondutor(cpf),
    enabled: cpf.length === 11,
    // O dado muda a cada alteração feita nesta própria tela; cache aqui só
    // atrapalharia a conferência do antes/depois durante a demonstração.
    staleTime: 0,
  });
}
